




















import { defineComponent, type PropType } from "vue-demi";

export default defineComponent({
  name: "GGProductRating",
  model: {
    prop: "value",
    event: "click",
  },
  props: {
    count: {
      type: Number,
      required: true,
    },
    size: {
      type: String as PropType<"12" | "15" | "20" | "22" | "24" | "32">,
      default: "15",
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    status() {
      switch (Math.round(this.count)) {
        case 1:
          return "Плохо";
        case 2:
          return "Не понравился";
        case 3:
          return "Понравился";
        case 4:
          return "Хорошо";
        case 5:
          return "Рекомендует этот товар";
        default:
          return "";
      }
    },
  },
});
